module.exports = '1.1.1';



//////////////////
// WEBPACK FOOTER
// ./~/sockjs-client/lib/version.js
// module id = 50
// module chunks = 0